import { EmbedLevel, getProfilePath } from '@/common'
import Store from '@/store'
import Session from '@/store/session'
import React from 'react'

export function useEmbedLink(type: string) {
  const isCC = Session.useSelector((state) => (state.user?.active ?? 0) >= EmbedLevel)
  const storeid = Store.useSelector((store) =>
    store.imported && store.imported.modified !== 'heavy' ? store.imported.id : undefined
  )

  return React.useMemo(() => {
    if (!isCC || !storeid) return
    const url = new URL(getProfilePath(storeid, 'planner'), window.location.href)
    url.hash = `#planner&${type}`
    return url.href
  }, [isCC, storeid, type])
}
